module.exports = __webpack_public_path__ + "img/icon-asset-load.636a0b87.png";